<template>
  <TransferLogic is-verify />
</template>
<script>
import TransferLogic from '@/views/center-business/stock/transfer/logic/index';
export default {
  name: 'BusinessStockVerifyLogicIndex',
  components: {
    TransferLogic,
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
